import { apiGetClient, apiPostClient, apiPutClient, apiPostImageClient } from "../../api/apiSurveys";
import { toast } from 'react-toastify';

export const getUserSurveys = async (languageId) => {
    try {
          const response = await apiGetClient.get(`surveys/user-surveys/${languageId}`);
          toast.success(response.data.data,{position: "top-center",theme: "dark"});
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getUserSurveysQuestions = async (surveyId, languageId) => {
    try {
          const response = await apiGetClient.get(`surveys/${surveyId}/details/${languageId}`);
          toast.success(response.data.data,{position: "top-center",theme: "dark"});
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const submitUserSurveysResponse = async (data, languageId) => {
    try {
          const response = await apiPostClient.post(`surveys/response/user/${languageId}`, data);
          toast.success(response.data?.data,{position: "top-center",theme: "dark"});
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};
